export default {"src":"/ai/_next/static/media/edit_logo_filled.9ca939a5.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};